import React, { useState, useEffect, useContext } from "react";
import "./ItemDetailContainer.css";
import { useParams } from "react-router-dom";
import { ItemDetail } from "../ItemDetail/ItemDetail";
import { Spinner, Flex } from "@chakra-ui/react";
import { getProduct } from "../../data/asyncMock";
import CartContext from "../../Context/CartContext";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../utils/config";
export const ItemDetailContainer = ({ functionNav }) => {
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  const { productId } = useParams();
  const { currentQuantity } = useContext(CartContext);
  // functionNav(false)

  // useEffect es un gancho de React que permite realizar efectos secundarios en componentes funcionales
  // Se ejecutará cada vez que cambie la dependencia [productId]
  useEffect(() => {
    // getProduct es una función asincrónica que obtiene un producto específico según su ID
    const getProduct = async () => {
      // Se crea una referencia al documento específico en la colección "products" con el ID proporcionado
      const queryRef = doc(db, "products", productId);

      // Se realiza la consulta para obtener el documento
      const response = await getDoc(queryRef);

      // Se crea un nuevo objeto newItem con la propiedad 'id' y los datos del documento
      const newItem = {
        id: response.id, // Se asigna el ID del documento como propiedad 'id'
        ...response.data(), // Se copian los datos del documento
      };

      // Se establece un temporizador de 1000 milisegundos (1 segundo) antes de actualizar el estado
      setTimeout(() => {
        // Se actualiza el estado 'product' con el nuevo objeto de producto
        setProduct(newItem);
        // Se actualiza el estado 'loading' a 'false' para indicar que la carga ha finalizado
        setLoading(false);
      }, 1000);
    };

    // Se llama a la función getProduct al montar el componente o cuando cambia productId
    getProduct();
  }, [productId]);

  console.log(currentQuantity(productId));
  return loading ? (
    <Flex align="center" justify="center">
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
        mt="5rem"
      />
    </Flex>
  ) : (
    <div className="containerDetail">
      <ItemDetail {...product} currentQuantity={currentQuantity(productId)} />
    </div>
  );
};
